export default "__VITE_ASSET__CPCi7m8j__"